import {connect} from 'react-redux'
import {AppDispatch} from 'Store'
import {ProtectedRouteComponent} from './ProtectedRouteComponent'
import {getUser} from 'Store/Actions/AuthActions'
import {RootState} from 'Store/Reducers'

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getUser: () => dispatch(getUser()),
})

export const ProtectedRoute = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProtectedRouteComponent)
